import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { ProductsService } from '@brafton/atlas-api-client';
import { Template } from '@brafton/common-framework-library';
import { IPagedList } from '@brafton/skynet-angular-security-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-sow-type',
  templateUrl: './filter-panel-sow-type.component.html',
  styleUrls: ['./filter-panel-sow-type.component.scss'],
  host: { class: 'filter-panel-sow-type' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelSowTypeComponent implements OnInit {
  @Input() sowTypes: Filter[] = [];
  @Output() sowTypesChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  templates$!: Observable<Template[]>;

  constructor(private productService: ProductsService) {}

  ngOnInit() {
    this.templates$ = this.productService
      .listTemplates(1, 250, 'ProductHead', true, undefined, 'Contract')
      .pipe(map((r: IPagedList<Template>) => r.items ?? []));
  }

  addProduct(templateDef: Template) {
    if (!this.sowTypes.find((sp) => sp.value === templateDef.id)) {
      this.sowTypes.push({ value: templateDef.id, displayName: templateDef.name, type: 'sow-type' } as Filter);
    }
    this.sowTypesChange.emit(this.sowTypes);
  }

  removeProduct(templateDef: Template) {
    const index = this.sowTypes.findIndex((sp) => sp.value === templateDef.id);
    if (index > -1) {
      this.sowTypes.splice(index, 1);
    }
    this.sowTypesChange.emit(this.sowTypes);
  }

  clear() {
    this.sowTypes = [];
    this.sowTypesChange.emit(this.sowTypes);
  }

  isSelected(templateDef: Template): boolean {
    if (!this.sowTypes) return false;
    if (this.sowTypes.find((sp) => sp.value === templateDef.id)) return true;
    else return false;
  }
}
